import styled from 'styled-components';
import { FOOTER_HEIGHT } from '../../const';
export const ColumnGrid = styled.div.withConfig({
  displayName: "Grids__ColumnGrid",
  componentId: "sc-1ivddpw-0"
})(["display:grid;grid-auto-columns:min-content;grid-auto-flow:column;column-gap:6px;align-items:center;"]);
export const ColumnMinAuto = styled(ColumnGrid).withConfig({
  displayName: "Grids__ColumnMinAuto",
  componentId: "sc-1ivddpw-1"
})(["grid-template-columns:min-content auto;"]);
export const ColumnAutoMin = styled(ColumnGrid).withConfig({
  displayName: "Grids__ColumnAutoMin",
  componentId: "sc-1ivddpw-2"
})(["grid-template-columns:auto min-content;"]);
export const ColumnMinAutoMin = styled(ColumnGrid).withConfig({
  displayName: "Grids__ColumnMinAutoMin",
  componentId: "sc-1ivddpw-3"
})(["grid-template-columns:min-content auto min-content;"]);
export let RowGap = function (RowGap) {
  RowGap["none"] = "0";
  RowGap["small"] = "8px";
  RowGap["medium"] = "16px";
  return RowGap;
}({});
export const RowGrid = styled.div.withConfig({
  displayName: "Grids__RowGrid",
  componentId: "sc-1ivddpw-4"
})(["display:grid;grid-template-rows:auto;row-gap:", ";", ""], p => p.rowGap || RowGap.medium, p => p.hasExtraBottomPadding && `padding-bottom: 8px;`);
export const RowWithPadding = styled(RowGrid).withConfig({
  displayName: "Grids__RowWithPadding",
  componentId: "sc-1ivddpw-5"
})(["padding-inline-start:8px;"]);
export const InnerScreenGrid = styled(RowGrid).withConfig({
  displayName: "Grids__InnerScreenGrid",
  componentId: "sc-1ivddpw-6"
})(["padding:0 16px ", "px;"], FOOTER_HEIGHT);
export const InnerScreenGridShort = styled(RowGrid).withConfig({
  displayName: "Grids__InnerScreenGridShort",
  componentId: "sc-1ivddpw-7"
})(["padding:12px 16px;"]);